// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee20Circle: FC<MoneyBackGuarantee20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm2.042 16.791-2.151-2.17-.93.93 3.081 3.1L19 13.69l-.93-.93-4.028 4.03Zm-7.73-10.39c-.352 0-.66.13-.92.391a1.261 1.261 0 0 0-.392.92v7.88c0 .362.13.667.392.916.26.249.568.38.92.392h3.063v-1.312H6.312V7.713h11.375v1.312H6.313v2.625H19V7.713c0-.352-.13-.66-.392-.921a1.26 1.26 0 0 0-.92-.392H6.313Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default MoneyBackGuarantee20Circle;
